import { TmApiRetryAfterError } from '@/core/error/transport/tmApiRetryAfterError'

export class TmAuthVerificationTryAgainInTimeError extends TmApiRetryAfterError {
  public name = 'TmAuthVerificationTryAgainInTimeError'
}
